<template>
  <span
    class="brand-logo"
    :class="[
      'brand-logo--' + variant,
      'brand-logo--' + context,
    ]"
  >
    <template v-if="variant === 'full'">
      <img
        v-if="context !== 'auth'"
        :src="branding.defaultIcon"
        alt=""
        aria-hidden="true"
        class="brand-logo-icon"
      />
      <img
        :src="branding.defaultWordmark"
        :alt="alt"
        class="brand-logo-wordmark"
      />
    </template>

    <img
      v-else-if="variant === 'wordmark'"
      :src="branding.defaultWordmark"
      :alt="alt"
      class="brand-logo-wordmark-only"
    />

    <img
      v-else
      :src="branding.defaultIcon"
      :alt="alt"
      class="brand-logo-compact"
    />
  </span>
</template>

<script>
import Session from '@/handler/session'
import Branding from './branding'
import { EventBus } from '@/handler/event-bus'

export default {
  name: 'BrandLogo',
  props: {
    variant: {
      type: String,
      default: 'full',
      validator: value => ['full', 'compact', 'wordmark'].indexOf(value) !== -1,
    },
    context: {
      type: String,
      default: 'navbar',
      validator: value => ['navbar', 'auth'].indexOf(value) !== -1,
    },
    alt: {
      type: String,
      default: 'Zyncro',
    },
  },
  data() {
    const session = Session.getSession()
    return {
      branding: Branding.resolve(session && session.settings),
    }
  },
  created() {
    EventBus.$on('Settings:settings', this.refreshBranding)
  },
  mounted() {
    this.refreshBranding()
  },
  beforeDestroy() {
    EventBus.$off('Settings:settings', this.refreshBranding)
  },
  methods: {
    refreshBranding() {
      const session = Session.getSession()
      this.branding = Branding.resolve(session && session.settings)
    },
  },
}
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  line-height: 0;
}

.brand-logo--full {
  gap: 5px;
}

.brand-logo--navbar.brand-logo--full {
  width: 150px;
  height: 48px;
}

.brand-logo--navbar .brand-logo-icon {
  width: 32px;
  height: 32px;
}

.brand-logo--navbar .brand-logo-wordmark {
  width: 88px;
  height: auto;
  transform: translateY(3px);
}

.brand-logo--navbar.brand-logo--compact {
  width: 48px;
  height: 48px;
}

.brand-logo--navbar.brand-logo--wordmark {
  width: 110px;
  height: 48px;
}

.brand-logo--navbar .brand-logo-compact {
  width: 32px;
  height: 32px;
}

.brand-logo--auth.brand-logo--full {
  display: flex;
  width: 210px;
  height: 75px;
  margin-right: auto;
  margin-left: auto;
}

.brand-logo--auth .brand-logo-icon {
  width: 57px;
  height: 57px;
}

.brand-logo--auth .brand-logo-wordmark {
  width: 185px;
  height: auto;
  transform: none;
}

.brand-logo-custom,
.brand-logo-compact,
.brand-logo-wordmark-only {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.brand-logo--navbar .brand-logo-wordmark-only {
  width: 100px;
  height: auto;
}
</style>
